// import pages
import SubHeader from "../layout/SubHeader";
import SubFooter from "../layout/SubFooter";
import SubTitle from "../../components/SubTitle";

const VideoView = () => {
  return (
    <div className="video-view-section">
      <SubHeader />
      <div className="container video-section">
        <SubTitle title="Videos" subTitle="動画" />
        <div className="video-footer-section">
          <p className="video-footer-text font-amaticsc-bold">
            Under Construction
          </p>
          <p className="video-footer-subtext font-zenkurenaido">工事中</p>
        </div>
      </div>
      <SubFooter />
    </div>
  );
};

export default VideoView;
